<template>
  <b-card>
    <b-row>
      <b-col sm="8" class="pb-1">
        <!-- <b-button
          variant="outline-primary"
          :to="{ name: 'organization-role-add' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          />
          {{ $t('message.Add_Role') }}
        </b-button> -->
      </b-col>
      <b-col sm="4">
        <b-form-group>
          <b-form-input
            v-model="searchQuery"
            :placeholder="$t('message.search')"
            type="search"
            class="d-inline-block"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-table
          ref="refPendingConfirmationsListTable"
          :items="pendingConfirmations"
          hover
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty=""
          :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="isSortDirDesc"
        >

          <template #cell(date)="data">
            {{ data.item.date }}
          </template>

          <template #cell(worker)="data">
            {{ data.item.workerName.length ? data.item.workerName[0].name : "" }}
          </template>

          <template #cell(process)="data">
            {{ data.item.processName.length ? data.item.processName[0].name : "" }}
          </template>

          <template #cell(actions)="data">
            <div class="flex flex-column">
              <EditButton @clicked="router.push({name:'habit-confirmation-edit', params: { id: data.item._id }})" />
              <DeleteButton v-b-modal="`modal ${data.item._id}`"/>
              <b-modal
                :id="`modal ${data.item._id}`"
                centered
                no-close-on-backdrop
                modal-class="modal-danger"
                ok-variant="danger"
                cancel-variant="outline-secondary"
                :title="$t('message.confirm_action')"
                :ok-title="$t('message.delete')"
                :cancel-title="$t('message.cancel')"
                @ok="deletePendingConfirmation(data.item._id)"
              >
                {{ $t('message.confirm_delete_pending_confirmation') }}
              </b-modal>
            </div>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
        class="d-flex justify-content-between flex-wrap"
      >
        <div class="mb-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ $t('message.per_page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="perPageOptions"
              class="w-50"
            />
          </b-form-group>
        </div>

        <div class="mb-1">
          <span class="text-muted">{{ showingMessage }}</span>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalPendingConfirmations"
          :per-page="perPage"
          first-number=""
          last-number=""
          prev-class="prev-item"
          next-class="next-item"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BPagination, BTable, BModal, VBModal } from 'bootstrap-vue'
import { onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import EditButton from '@/views/components/Shared/Buttons/EditButton'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton'
import usePendingConfirmationsList from './usePendingConfirmationsList'

export default {
  components: {
    BTable,
    BPagination,
    EditButton,
    DeleteButton,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup() {
    const { router } = useRouter()

    const {
      fetchPendingConfirmations,
      tableColumns,
      perPage,
      currentPage,
      perPageOptions,
      totalPendingConfirmations,
      showingMessage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      pendingConfirmations,
      deletePendingConfirmation,
      isLoading,
    } = usePendingConfirmationsList()

    onMounted(() => {
      fetchPendingConfirmations()
    })

    return {
      fetchPendingConfirmations,
      pendingConfirmations,
      showingMessage,
      router,
      tableColumns,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deletePendingConfirmation,
      totalPendingConfirmations,
      currentPage,
      perPageOptions,
      perPage,
      isLoading,
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.process-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

.form-group {
  label {
    font-size: 0.85rem;
    font-weight: 400;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
